export const PERSONAL_DATA_STEP_ROUTE = 'dane-osobowe';
